
export function formatString(str: string, limit?: number | null) {
  const isOverLimit = limit && str.length > limit;
  const ellipse = ""; // show an elipse? for now, no.
  return limit ? `${str.slice(0, limit)}${isOverLimit ? ellipse : ""}` : str;
}
